import Utils from './utils.js';

const Animations = {
	'template-home': {
		_enter( args ){
			const tl = gsap.timeline( {
				paused: true
			} );

			tl.to( '#site__header', {
				duration: 0.3,
				autoAlpha: 1
			} );

			return tl;
		},
		_leave( args ){
			const tl = gsap.timeline( {
				paused: false
			} );

			tl.to( '#site__header', {
				autoAlpha: 0,
				duration: 0.3
			} );
			
			return Utils.timelinePromise( tl );
		}
	},
	'template-veranstaltungen-uebersicht': {
		_enter( args ){
			const tl = gsap.timeline( {
				paused: true
			} );

			tl.to( '#site__header', {
				duration: 0.3,
				autoAlpha: 1
			} );
			
			return tl;
		},
		_leave( args ){
			const tl = gsap.timeline( {
				paused: false
			} );

			tl.to( '#site__header', {
				duration: 0.3,
				autoAlpha: 0
			} );			
			
			return Utils.timelinePromise( tl );
		}
	}
};

export default Animations;
